<template>
  <RouterLink v-slot="{ isActive, href, navigate }" custom :to="linkTarget">
    <a
      :href="href"
      class="ChatHistory__list-link"
      @click="
        (event) => {
          navigate(event)
          $emit('onChatClick')
        }
      "
    >
      <ChatHistoryItem
        :chat="chat"
        :isActive="isActive"
        :showContextMenu="showContextMenu"
        :isExpiring="isExpiring"
      />
    </a>
  </RouterLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { storeToRefs } from 'pinia'

import type { IChatListItem } from '@/apiClient/types/chat'
import { useAppStore } from '@/store/app'

import ChatHistoryItem from './ChatHistoryItem.vue'

const props = withDefaults(
  defineProps<{
    chat: IChatListItem
    showContextMenu?: boolean
    /** Renders the amber "expiring soon" badge next to the chat title. */
    isExpiring?: boolean
  }>(),
  {
    showContextMenu: true,
    isExpiring: false,
  },
)

defineEmits(['onChatClick'])

const { isNotAuthorisedPage: isNotAuthorised } = storeToRefs(useAppStore())

const linkTarget = computed(() =>
  !isNotAuthorised.value
    ? { name: 'Chat', params: { id: props.chat.id } }
    : { name: 'NotAuthorised' },
)
</script>

<style scoped lang="scss">
.ChatHistory__list-link {
  display: block;
  width: 100%;
  min-width: 0;
  text-decoration: none;
  color: var(--text-primary);

  &:hover {
    // Reveal the actions toggle by expanding it (see ChatHistoryItem for the base
    // collapsed state) so the icon eases in and the expiring badge slides aside.
    :deep(.ChatHistoryItem__more) {
      width: 1.75rem;
      opacity: 1;
    }
  }
}
</style>
